import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'paths',
            name: 'path',
            class: 'App\\Models\\Path'
        }
    }
}